const Restore = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 9.00041C14.7348 9.00041 14.4804 9.10576 14.2929 9.2933C14.1054 9.48084 14 9.73519 14 10.0004V13.0004H2V6.00041H11.586L9.293 8.29341C9.19749 8.38565 9.12131 8.496 9.0689 8.618C9.01649 8.74001 8.9889 8.87123 8.98775 9.00401C8.9866 9.13679 9.0119 9.26847 9.06218 9.39136C9.11246 9.51426 9.18671 9.62591 9.28061 9.7198C9.3745 9.81369 9.48615 9.88795 9.60905 9.93823C9.73194 9.98851 9.86362 10.0138 9.9964 10.0127C10.1292 10.0115 10.2604 9.98392 10.3824 9.93151C10.5044 9.8791 10.6148 9.80292 10.707 9.70741L14.707 5.70741C14.8945 5.51988 14.9998 5.26557 14.9998 5.00041C14.9998 4.73524 14.8945 4.48094 14.707 4.29341L10.707 0.293407C10.5184 0.111249 10.2658 0.0104547 10.0036 0.0127331C9.7414 0.0150115 9.49059 0.12018 9.30518 0.305589C9.11977 0.490997 9.0146 0.741809 9.01233 1.00401C9.01005 1.2662 9.11084 1.5188 9.293 1.70741L11.586 4.00041H2C1.46957 4.00041 0.960859 4.21112 0.585786 4.58619C0.210714 4.96127 0 5.46997 0 6.00041L0 13.0004C0 13.5308 0.210714 14.0395 0.585786 14.4146C0.960859 14.7897 1.46957 15.0004 2 15.0004H14C14.5304 15.0004 15.0391 14.7897 15.4142 14.4146C15.7893 14.0395 16 13.5308 16 13.0004V10.0004C16 9.73519 15.8946 9.48084 15.7071 9.2933C15.5196 9.10576 15.2652 9.00041 15 9.00041Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Restore
